import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormInput } from "go-form";
import FormNumberInput from "go-form/components/FormNumberInput";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";
import { SearchSelectApi } from "../../../../../../../../../services/Api/types";
import { AppState } from "../../../utils/types";

interface Props {
	appState?: AppState;
	form: UseFormReturn<ApplicationUpdateApi>;
}

const KWHotelForm = ({ form, appState }: Props) => {
	const { t } = useTranslation();
	const [updatedConfig, setUpdatedConfig] = useState<Record<string, any> | undefined>(appState?.config);
	const {
		register,
		setValue,
		formState: { errors },
		control,
		clearErrors,
	} = form;
	const organization = useSelector(selectOrganization);

	const searchPaymentMethods = (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getPaymentMethodsSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	const updatePort = (evt: React.ChangeEvent<HTMLInputElement>) => {
		clearErrors("settings.ip_address");
		if ((evt.nativeEvent as InputEvent).inputType === "deleteContentBackward") {
			return;
		}
		const value = evt.target.value;
		let finalValue;
		if (value.slice(value.length - 2) === "..") {
			setValue(`settings.ip_address`, value.slice(0, -1));
			return;
		}
		if (value.split(".").length > 3) {
			const values = value.split(".");
			let splitted = value.split(".")[3];
			if (splitted.length > 3) {
				splitted = splitted.slice(0, 3);
			}
			setValue(`settings.ip_address`, `${values[0]}.${values[1]}.${values[2]}.${splitted}`);
			return;
		}
		if (value.length === 3) {
			if (!isNaN(Number(value)) && Number(value) % 1 === 0 && value.slice(value.length - 1) !== ".") {
				finalValue = `${value}.`;
				setValue(`settings.ip_address`, finalValue);
			}
		}
		if (value.length > 3) {
			const sliced = value.slice(value.length - 3);
			if (Number(sliced) % 1 === 0 && sliced.slice(sliced.length - 1) !== ".") {
				finalValue = `${value}.`;
				setValue(`settings.ip_address`, finalValue);
			}
		}
	};

	const updateConfig = (field: string, obj?: SearchSelectApi) => {
		const cnf = { ...updatedConfig };
		if (field === "payment_method_name") {
			cnf.payment_method_name = obj?.label;
		}
		setUpdatedConfig(cnf);
	};

	return (
		<>
			<FormSelectGroup
				name="settings.payment_method_id"
				getOptionValue={(option) => option.id}
				path={`/${organization.id}/settings/payment_methods/`}
				control={control}
				loadOptions={searchPaymentMethods}
				label={t("modules.app.field.default_payment_method.title")}
				defaultValue={{
					label: updatedConfig?.payment_method_name,
					id: appState?.app?.settings?.payment_method_id,
				}}
				onChange={(_, fullObj) => updateConfig("payment_method_name", fullObj)}
				errors={errors}
				data-testid="settings.payment_method_id"
			/>
			<div className={"app-advanced mt-4"}>
				<strong>{t("common.word.advanced", { ns: "lib" })}</strong>
			</div>
			<FormNumberInput
				errors={errors}
				name="settings.port"
				label={t("modules.app.field.port.title")}
				defaultValue="11002"
				onChange={() => clearErrors("settings.port")}
				control={control}
				suffix=""
			/>
			<FormInput
				label={t("lib:common.word.ip_address")}
				name={"settings.ip_address"}
				onChange={(val: React.ChangeEvent<HTMLInputElement>) => updatePort(val)}
				errors={errors}
				register={register}
			/>
			<FormInput
				label={t("modules.app.field.file_path.title")}
				name={"settings.file_path"}
				errors={errors}
				register={register}
			/>
		</>
	);
};
export default KWHotelForm;
